// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file cortado/v1/waitlist.proto (package cortado.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file cortado/v1/waitlist.proto.
 */
export const file_cortado_v1_waitlist: GenFile = /*@__PURE__*/
  fileDesc("Chljb3J0YWRvL3YxL3dhaXRsaXN0LnByb3RvEgpjb3J0YWRvLnYxImMKFVN1Ym1pdFdhaXRsaXN0UmVxdWVzdBINCgVlbWFpbBgBIAEoCRISCgpmaXJzdF9uYW1lGAIgASgJEhEKCWxhc3RfbmFtZRgDIAEoCRIUCgxjb21wYW55X25hbWUYBCABKAkiJAoWU3VibWl0V2FpdGxpc3RSZXNwb25zZRIKCgJpZBgBIAEoCUImWiRodWItYmFja2VuZC9nZW4vY29ydGFkby92MTtjb3J0YWRvdjFiBnByb3RvMw");

/**
 * SubmitWaitlistRequest is sent to add an entry to the waitlist
 *
 * @generated from message cortado.v1.SubmitWaitlistRequest
 */
export type SubmitWaitlistRequest = Message<"cortado.v1.SubmitWaitlistRequest"> & {
  /**
   * Email address (required)
   *
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * First name
   *
   * @generated from field: string first_name = 2;
   */
  firstName: string;

  /**
   * Last name
   *
   * @generated from field: string last_name = 3;
   */
  lastName: string;

  /**
   * Company name
   *
   * @generated from field: string company_name = 4;
   */
  companyName: string;
};

/**
 * Describes the message cortado.v1.SubmitWaitlistRequest.
 * Use `create(SubmitWaitlistRequestSchema)` to create a new message.
 */
export const SubmitWaitlistRequestSchema: GenMessage<SubmitWaitlistRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_waitlist, 0);

/**
 * SubmitWaitlistResponse is returned after a waitlist entry is created
 *
 * @generated from message cortado.v1.SubmitWaitlistResponse
 */
export type SubmitWaitlistResponse = Message<"cortado.v1.SubmitWaitlistResponse"> & {
  /**
   * ID of the created waitlist entry
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.SubmitWaitlistResponse.
 * Use `create(SubmitWaitlistResponseSchema)` to create a new message.
 */
export const SubmitWaitlistResponseSchema: GenMessage<SubmitWaitlistResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_waitlist, 1);

